export default __webpack_public_path__ + "static/media/jet.8e409811.jpg";